import { BookingSeatsComponent } from "./booking/booking-seats/booking-seats.component";
import { bookingComponents } from "./booking";
import { ColorComponent } from "./color/color.component";
import { communicationsComponents, MessageRedirectButtonComponent } from "./communications";
import { CustomToggleComponent } from "./custom-toggle/custom-toggle.component";
import { DarkModeComponent } from "./dark-mode/dark-mode.component";
import { markers } from "./markers";
import { SeatsComponent } from "./seats/seats.component";
import { serviceComponents } from "./service";
import { ServiceTagComponent } from "./service-tag/service-tag.component";
import { setupComponents } from "./setups";
import { tripComponents } from "./trips";
import { userComponents } from "./users";
import { vehicleComponents } from "./vehicles";

export {
  ColorComponent,
  CustomToggleComponent,
  DarkModeComponent,
  SeatsComponent,
  ServiceTagComponent,
};

export const components = [
  ...bookingComponents,
  ...markers,
  ...serviceComponents,
  ...setupComponents,
  ...tripComponents,
  ...userComponents,
  ...vehicleComponents,
  ...communicationsComponents,
  DarkModeComponent,
  SeatsComponent,
]

export const standaloneComponents = [
  ColorComponent,
  CustomToggleComponent,
  ServiceTagComponent,
  BookingSeatsComponent,
  MessageRedirectButtonComponent,
];
